import "./MfaModalDialog.scss";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PulseDialog } from "@pulselabs-ai/shared-fe-ui";
import React from "react";

interface ShellDialogProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  hasBackDrop?: boolean;
  paperStyles?: React.CSSProperties;
  className?: string;
  onBack?: () => void;
}

const ShellDialog: React.FC<ShellDialogProps> = ({
  isOpen,
  onClose,
  children,
  hasBackDrop = false,
  paperStyles,
  className,
  onBack,
}) => {
  return (
    <PulseDialog
      isOpen={isOpen}
      onClose={onClose}
      className={`shell-theme-dialog ${className}`}
      paperStyles={
        paperStyles ?? {
          borderRadius: "16px 16px 0 0",
          height: "100%",
          margin: "0 32px",
          maxHeight: "100%",
        }
      }
      hasBackDrop={hasBackDrop}
    >
      {onBack && (
        <ArrowBackIcon onClick={onBack} className="shell-dialog-back-icon" />
      )}
      {children}
    </PulseDialog>
  );
};

export default ShellDialog;
